// extracted by mini-css-extract-plugin
export default {"title":"GettingStartedCard_title__a6fWy","subTitle":"GettingStartedCard_subTitle__CTr7X","card":"GettingStartedCard_card__dJaaq"};